import {
	lazy,
} from 'react'

export const RulesPageAsync = lazy(async() => {
	return import('./rules.page')
})
